import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import * as moment from 'moment';

@Pipe({ name: 'dateTablePipe' })
export class DateTablePipe implements PipeTransform {
  transform(value: string): string {
    return new DatePipe('es-CL').transform(value);
  }
}

// tslint:disable-next-line: max-classes-per-file
@Pipe({ name: 'currencyTablePipe' })
export class CurrencyTablePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '$ 0';
    }
    return `$ ${new DecimalPipe('es-CL').transform(value, '1.0-0')}`;
  }
}

// tslint:disable-next-line: max-classes-per-file
@Pipe({ name: 'percentageTablePipe' })
export class PercentageTablePipe implements PipeTransform {
  transform(value: any): string {
    return `${new DecimalPipe('es-CL').transform(value * 100)} %`;
  }
}

// tslint:disable-next-line: max-classes-per-file
@Pipe({ name: 'purePercentageTablePipe' })
export class PurePercentageTablePipe implements PipeTransform {
  transform(value: any): string {
    return `${new DecimalPipe('es-CL').transform(value)} %`;
  }
}

// tslint:disable-next-line: max-classes-per-file
@Pipe({ name: 'dateNombreMesTablePipe' })
export class DateNombreMesTablePipe implements PipeTransform {
  transform(value: any, format = 'MM-YYYY'): string {
    moment.locale('es-es');
    return moment(value, format).format('MMMM YYYY');
  }
}

// tslint:disable-next-line: max-classes-per-file
@Pipe({ name: 'edadTablePipe' })
export class EdadTablePipe implements PipeTransform {
  transform(value: any, format = 'MM-YYYY'): string {
    return `${value} años`;
  }
}
